export default {
  actionToExecute: 'Auszuführende Aktion',
  addAction: 'Aktion hinzufügen',
  addListToSequence: 'Liste zur Sequenz hinzufügen',
  addPerson: 'Person hinzufügen',
  addPersonOrStep: 'Person oder Schritt hinzufügen',
  addScheduleName: 'Name des Zeitplans hinzufügen',
  addScheduleObservations: 'Zeitplanbeobachtungen hinzufügen',
  addStep: 'Schritt hinzufügen',
  addTask: 'Aufgabe hinzufügen',
  addTrigger: 'Trigger hinzufügen',
  addUserToSequence: 'Benutzer zur Sequenz hinzufügen',
  automaticEmail: 'Automatische E-Mail',
  changeUserFromSequence: 'Benutzer von Sequenz ändern',
  companyName: 'Name des Unternehmens',
  completion: 'Fertigstellung',
  continueWithoutSaving: 'Ohne Speichern fortfahren',
  copyCustomizedField: 'Benutzerdefiniertes Feld kopieren',
  couldNotCopyFieldToClipboard: 'Konnte Feld nicht in die Zwischenablage kopieren',
  createAValidTask: 'Erstellen einer gültigen Aufgabe',
  createRule: 'Regel erstellen',
  createSequence: 'Sequenz erstellen',
  customFieldSuccessfullyCopiedToClipboard: 'Benutzerdefiniertes Feld erfolgreich in die Zwischenablage kopiert',
  customizeDay: 'Tag anpassen',
  customizeScheduleDays: 'Plantage anpassen',
  dayDisabled: 'Tag deaktiviert',
  days: 'Tage',
  deleteAction: 'Aktion löschen',
  deleteList: 'Liste löschen',
  deleteSequence: 'Sequenz löschen',
  deleteTrigger: 'Trigger löschen',
  deleteUserFromSequence: 'Benutzer aus der Sequenz löschen',
  deleteUserFromSequenceConfirmation: 'Wollen Sie diesen Benutzer wirklich aus der Sequenz',
  doNothing: 'Nichts tun',
  doYouReallyWanToDeleteThisSequence: 'Wollen Sie diese Sequenz wirklich löschen?',
  editList: 'Liste bearbeiten',
  editPerson: 'Person bearbeiten',
  editRule: 'Regel bearbeiten',
  editSchedule: 'Zeitplan bearbeiten',
  emailHooksInformation: 'Informationen über E-Mail-Hooks',
  emailStatistics: 'E-Mail-Statistik',
  enterRuleDescription: 'Regelbeschreibung eingeben',
  editSequence: 'Reihenfolge bearbeiten',
  editStep: 'Schritt Bearbeiten',
  enterRuleName: 'Regelname eingeben',
  enterStepName: 'Schrittname eingeben',
  enterStepOrder: 'Schrittfolge eingeben',
  enterStepTips: 'Schritttipps eingeben',
  enterTaskName: 'Aufgabenname eingeben',
  enterTriggerName: 'Triggernamen eingeben',
  executeAnotherActionInAGivenTime: 'Ausführen einer anderen Aktion in einer bestimmten Zeit',
  exitWhen: 'Beenden, wenn',
  goBackToTheSequence: 'Zurück zur Sequenz',
  hours: 'Stunden',
  ifNotSequenceStepPickedNote: 'Hinweis: Wenn Sie keinen Schritt auswählen, wird standardmäßig der nächste Sequenzschritt ausgewählt.',
  insertEmailSubject: 'E-Mail-Betreff einfügen',
  isActive: 'Ist aktiv',
  isDayActive: 'Ist Tag aktiv',
  isGlobal: 'Ist global',
  isSequenceActive: 'Ist Sequenz aktiv',
  isStepActive: 'Ist Schritt aktiv',
  lastEditionDate: 'Datum der letzten Ausgabe',
  listNotFound: 'Liste nicht gefunden',
  listSuccessfullyAddedToSequence: 'Liste erfolgreich zur Sequenz hinzugefügt',
  listView: 'Listenansicht',
  loadingInformation: 'Laden von Informationen',
  loadingRule: 'Regel laden',
  loadingSchedule: 'Zeitplan für das Laden',
  loadingSequence: 'Ladereihenfolge',
  loadingSequenceStatistics: 'Statistik der Ladereihenfolge',
  loadingStep: 'Schritt zum Laden',
  manualEmail: 'Manuelle E-Mail',
  nestedActionToExecute: 'Verschachtelte auszuführende Aktion',
  newRule: 'Neue Regel',
  newSchedule: 'Neuer Zeitplan',
  newSequence: 'Neue Reihenfolge',
  noRulesCreated: 'Keine Regeln erstellt',
  noSchedulesCreated: 'Keine Zeitpläne erstellt',
  noSequencesCreated: 'Keine Sequenzen erstellt',
  order: 'Bestellung',
  owner: 'Eigentümer',
  pauseSequence: 'Pausen-Sequenz',
  peopleInTheSequence: 'Personen in der Reihenfolge',
  peoplePerStep: 'Personen pro Schritt',
  peopleThatLeftTheSequence: 'Personen, die die Sequenz verlassen haben',
  personSuccessfullyAddedToSequence: 'Person erfolgreich zur Sequenz hinzugefügt',
  personSuccessfullyChangedFromSequence: 'Person erfolgreich von Sequenz gewechselt',
  personSuccessfullyCreated: 'Person erfolgreich erstellt',
  personSuccessfullyUpdated: 'Person erfolgreich aktualisiert',
  pickAnAction: 'Wählen Sie eine Aktion aus',
  pickAnHour: 'Wählen Sie eine Stunde',
  pickADate: 'Wählen Sie ein Datum aus',
  pickARule: 'Wählen Sie eine Regel',
  pickASchedule: 'Wählen Sie einen Zeitplan',
  pickAScheduleForTheSequence: 'Wählen Sie einen Zeitplan für die Sequenz',
  pickAStep: 'Wählen Sie einen Schritt aus',
  pickFinishingTime: 'Endzeit auswählen',
  pickHour: 'Kommissionierstunde',
  pickMinutes: 'Minuten auswählen',
  pickTimeZone: 'Zeitzone auswählen',
  pickStartingDateTimeAndTimeZone: 'Wählen Sie das Startdatum, die Uhrzeit und die Zeitzone',
  pickStartingTime: 'Startzeit der Kommissionierung',
  pickTheSequenceToChangeTo: 'Wählen Sie die Sequenz aus, in die Sie wechseln möchten',
  pickTheStepToChangeTo: 'Wählen Sie den Schritt zum Wechsel zu',
  pickTriggerType: 'Pick-Trigger-Typ',
  prepareEmail: 'E-Mail vorbereiten',
  project: 'Projekt',
  relateRuleToSequence: 'Regel mit einer Sequenz verknüpfen',
  relateRuleToSequenceOrSetAsGlobal: 'Regel auf eine Sequenz beziehen oder als global festlegen',
  removeUserFromSequence: 'Benutzer aus der Sequenz entfernen',
  ruleDetails: 'Details zur Regel',
  ruleNotFound: 'Regel nicht gefunden',
  ruleSuccessfullyCreated: 'Regel erfolgreich erstellt',
  ruleSuccessfullyUpdated: 'Regel erfolgreich aktualisiert',
  rules: 'Regeln',
  runSequence: 'Laufsequenz',
  saveTemplate: 'Vorlage speichern',
  saveTemplateWarning: 'Sie haben diese Vorlage nicht gespeichert oder aktualisiert, sind Sie sicher, dass Sie ohne Speichern oder Aktualisieren fortfahren werden?',
  scheduleDays: 'Tage einplanen',
  scheduleName: 'Name des Zeitplans',
  scheduleObservations: 'Beobachtungen einplanen',
  scheduleSuccessfullyCreated: 'Zeitplan erfolgreich erstellt',
  scheduleSuccessfullyUpdated: 'Zeitplan erfolgreich aktualisiert',
  schedules: 'Zeitpläne',
  seeList: 'Siehe Liste',
  seePerson: 'Siehe Person',
  seeSequence: 'Siehe Sequenz',
  selectARule: 'Wählen Sie eine Regel',
  selectASequence: 'Wählen Sie eine Sequenz',
  sequence: 'Sequenz',
  sequenceCompany: 'Sequenz-Firma',
  sequenceDetails: 'Details zur Sequenz',
  sequenceInformationWillBeLostAfterDeletionOfTheSequence: 'Alle Leads, Schritte und Informationen, die sich auf die Sequenz beziehen, sind nicht mehr verfügbar.',
  sequenceLeads: 'Sequenz führt',
  sequenceName: 'Name der Sequenz',
  sequenceOwner: 'Besitzer der Sequenz',
  sequencePeople: 'Reihenfolge der Personen',
  sequenceRuleType: 'Regel-Typ',
  sequenceSchedule: 'Sequenz-Zeitplan',
  sequenceStatistics: 'Sequenz-Statistik',
  sequenceStatisticsNotFound: 'Sequenzstatistik nicht gefunden',
  sequenceStatus: 'Sequenz-Status',
  sequenceStatusSuccessfullyChanged: 'Sequenzstatus erfolgreich geändert',
  sequenceSteps: 'Sequenz-Schritte',
  sequenceSuccessfullyCreated: 'Sequenz erfolgreich erstellt',
  sequenceSuccessfullyDeleted: 'Sequenz erfolgreich gelöscht',
  sequenceSuccessfullyUpdated: 'Sequenz erfolgreich aktualisiert',
  sequences: 'Sequenzen',
  sequencesRules: 'Regeln für Sequenzen',
  sequencesList: 'Liste der Sequenzen',
  setRuleAsGlobal: 'Regel als global festlegen',
  sms: 'SMS',
  smsHooksInformation: 'Informationen zu Sms-Haken',
  smsStatistics: 'SMS-Statistik',
  social: 'Sozial',
  settings: 'Einstellungen',
  statistics: 'Statistik',
  step: 'Schritt',
  stepSuccessfullyCreated: 'Schritt erfolgreich erstellt',
  stepSuccessfullyUpdated: 'Schritt erfolgreich aktualisiert',
  stepTips: 'Tipps für Schritte',
  stepType: 'Schritttyp',
  task: 'Aufgabe',
  taskHooksInformation: 'Informationen zu den Aufgabenhaken',
  taskStatistics: 'Aufgaben-Statistik',
  templateSuccessfullySaved: 'Vorlage erfolgreich gespeichert',
  templateSuccessfullyUpdated: 'Vorlage erfolgreich aktualisiert',
  theSequenceIsRunningNow: 'Die Sequenz läuft jetzt',
  timeToFinishTheTaskAfterRuleGetsExecuted: "Zeit zum Beenden der Aufgabe nach der Ausführung der Regel get's",
  timeToWaitBeforeRunningThisStep: 'Wartezeit bis zur Ausführung dieses Schrittes',
  timeToWaitBeforeNestedActionGetsExecuted: 'Wartezeit bis zur Ausführung einer verschachtelten Aktion',
  tipsForTheStep: 'Tipps für die {type}',
  triggerName: 'Name des Auslösers',
  triggerActions: 'Aktionen auslösen',
  updateTemplateWarning: 'Die Vorlage {templateName} wird aktualisiert, sind Sie sicher?',
  userNotFound: 'Benutzer nicht gefunden',
  userSuccessfullyDeletedFromSequence: 'Benutzer erfolgreich aus Sequenz gelöscht',
  waitFor: 'Warten Sie auf',
  withoutTips: 'Ohne Tipps',
  writeEmail: 'E-Mail schreiben',
  writeSms: 'SMS schreiben',
  youMustFillAllFieldsCorrectly: 'Sie müssen alle Felder korrekt ausfüllen.',
  youMustPickADate: 'Sie müssen ein Datum wählen',
  pickAnOutcome: 'Wählen Sie ein Ergebnis',
  pickAnOutcomeForTheTask: 'Wählen Sie ein Ergebnis für die Aufgabe',
  pending: 'Steht aus | Steht aus',
  scheduled: 'Geplant | Geplant',
  queued: 'In Warteschlange | In Warteschlange'
}
